import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';

export const dateFieldDefaultProps = {
  MuiDateField: {
    defaultProps: {
      slotProps: {
        clearButton: { size: 'small' },
        textField: {
          inputProps: { 'data-qa-id': 'date-picker__date-input' },
          variant: 'outlined'
        }
      },
      slots: {
        clearButton: props => <InputAdornment position="start" {...props} />
      }
    }
  }
};
